import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
// import SignUp from './SignUp';
// import SignIn from './SignIn';
import Home from './Home';
// import Profile from './Profile';
import Post from './Post';
import NewPost from './NewPost';
import { Helmet } from 'react-helmet';

export default class Network extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div>
        <Helmet>
          <meta
            name="description"
            content="The DeWaste Network is an online platform where farmers, wholesalers, retailers and customers can connect with others"
          />

          <meta
            itemProp="name"
            content="DeWaste Network | Connecting food producers and buyers to reduce food waste"
          />
          <meta
            itemProp="description"
            content="The DeWaste Network is an online platform where farmers, wholesalers, retailers and customers can connect with others in their proximity and trade in these food items so they don't go to waste."
          />
          <meta
            itemProp="image"
            content="https://de-waste.com/network_logo.png"
          />

          <meta
            property="og:image"
            content="https://de-waste.com/network_logo.png"
          />
          <meta property="og:type" content="website" />
          <meta property="og:title" content="DeWaste Network" />
          <meta
            property="og:description"
            content="The DeWaste Network is an online platform where farmers, wholesalers, retailers and customers can connect with others."
          />
          <meta property="og:site_name" content="DeWaste" />
          <meta property="og:url" content="https://de-waste.com/network" />

          <meta name="twitter:card" content="summary" />
          <meta
            name="twitter:image"
            content="https://de-waste.com/network_logo.png"
          />
          <meta name="twitter:title" content="DeWaste Network" />
          <meta
            name="twitter:description"
            content="The DeWaste Network is an online platform where farmers, wholesalers, retailers and customers can connect with others."
          />

          <title>DeWaste Network | Connecting food producers and buyers</title>
        </Helmet>

        <Switch>
          <Route
            path="/network"
            exact
            render={(props) => (
              <Home
                signout={this.props.signout}
                user={this.props.user}
                searchValue={this.state.searchValue}
              />
            )}
          />
          <Route
            path="/network/post"
            render={(props) => (
              <Post
                signout={this.props.signout}
                user={this.props.user}
                searchValue={this.state.searchValue}
              />
            )}
          />
          <Route
            path="/network/newpost"
            render={(props) => <NewPost searchValue={this.state.searchValue} />}
          />
          {/*<Route*/}
          {/*  path="/network/signup"*/}
          {/*  exact*/}
          {/*  render={props => (<SignUp signup={this.props.signup}  user={this.props.user} />)}*/}
          {/*/>*/}
          {/*<Route*/}
          {/*  path="/network/signin"*/}
          {/*  exact*/}
          {/*  render={props => (<SignIn signin={this.props.signin} user={this.props.user} />)}*/}
          {/*/>*/}
          {/*<Route*/}
          {/*  path="/network/profile"*/}
          {/*  exact*/}
          {/*  render={props => (<Profile signout={this.props.signout} user={this.props.user} />)}*/}
          {/*/>*/}
        </Switch>
      </div>
    );
  }
}
